import { Link } from "react-router-dom";
import { SearchX } from "lucide-react";

/**
 * Top-level catch-all — renders for any path that doesn't match a
 * registered route (mistyped URL, stale bookmark, removed page).
 * Without this, React Router silently renders an empty <Outlet/>
 * inside CustomerShell — a blank white screen with no indication of
 * what went wrong.
 */
export default function NotFoundPage() {
    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="not-found-page">
            <div className="text-center max-w-sm">
                <SearchX size={40} className="mx-auto text-muted-foreground mb-4" />
                <h1 className="text-xl font-bold mb-1">Page not found</h1>
                <p className="text-sm text-muted-foreground mb-6">
                    The page you're looking for doesn't exist or may have moved.
                </p>
                <Link
                    to="/"
                    data-testid="not-found-home-link"
                    className="inline-block bg-primary text-primary-foreground rounded-xl px-5 py-2.5 font-semibold text-sm"
                >
                    Go to Home
                </Link>
            </div>
        </div>
    );
}
